import React, { useState, useCallback } from "react";
import { useEffect, useRef } from "react";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Media,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Row,
  Col,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./passenger.css";
import { T, TF, LanguageList, Config } from "react-translator-component";
import { translate } from "../../language/translations.js";
import { isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { AirlinesAutocompleteInput, ControlledTextInput, ProgramsSelectInput, ProgramsSelectInputNew, LanguageRadioInput } from "../inputs/index.jsx";
import { Wrapper, Container } from "../layout";
import { useModals } from "../../hooks/modals.jsx";
import TermsAndConditionModal from "../Modals/TermsAndConditionModal/TermsAndConditionModal.jsx";
import { useSubmit } from '../../hooks/fetch.jsx';
import { createWaitlistEntry } from '../../api/waitlist';
import { useApiConfig } from '../../hooks/useApiConfig';

const PassengerForm = () => {
  const defaultAreaCode = "1";
  const defaultLanguage = "en";
  const PageRef = useRef(null);

  const {
    toggleTermsAndConditionModal,
  } = useModals();

  const mutation = useSubmit();

  const { baseUrl, isUsingNewEndpoints, token: authToken, outletId } = useApiConfig();

  let initialPassengerState = {
    id: null,
    env: "",
    isProd: false,
    loungeCode: "",
    loungeName: "",
    language: "",
    waitlistEmailLogo: "",
    s3Url: "",
    name: "",
    email: "",
    phoneNumber: "",
    departureTime: "",
    flightNumber: "",
    guests: "",
    infants: "",
    programID: ""
  };

  let initialLoungeInfo = {
    LoungeName: "",
    LoungeCode: "",
    WaitlistEmailLogo: "",
  };

  let initialErrorsState = {
    error: false,
    errorMsg: "",
    nameErr: false,
    nameErrMsg: "",
    emailErr: false,
    emailErrMsg: "",
    phoneNumberErr: false,
    phoneNumberMsg: "",
    guestsErr: false,
    guestsErrMsg: "",
    infantsErr: false,
    infantsErrMsg: "",
    departureTimeErr: false,
    departureTimeMsg: "",
    flightNumberTimeErr: false,
    flightNumberTimeMsg: "",
    apiCallErr: false,
    apiCallErrMsg: "",
  };

  let phoneInformation = {
    countryCode: null,
    dialCode: null,
    name: null
  }

  // Sets default Language and list for available lang selections
  //Config.default = defaultLanguage;

  // List of Languages and files for translation text
  Config.list = {
    en: {
      text: "English",
      icon: "./flags/en.svg",
      file: translate.en,
    },
    // ar: {
    //   text: "عربي",
    //   icon: "./flags/ar.svg",
    //   file: translate.ar,
    // },
    // de: {
    //   text: "Deutsch",
    //   icon: "./flags/de.svg",
    //   file: translate.de,
    // },
    es: {
      text: "Español",
      icon: "./flags/es.svg",
      file: translate.es,
    },
    // fr: {
    //   text: "Français",
    //   icon: "./flags/fr.svg",
    //   file: translate.fr,
    // },
    // it: {
    //   text: "Italiano",
    //   icon: "./flags/it.svg",
    //   file: translate.it,
    // },
    pt: {
      text: "Portuguese",
      icon: "./flags/pt.svg",
      file: translate.pt,
    },
    // ru: {
    //   text: "Pусский",
    //   icon: "./flags/ru.svg",
    //   file: translate.ru,
    // },
  };

  const [loading, setLoading] = useState(false);
  const [areaCode, setAreaCode] = useState(defaultAreaCode);
  const [AirlineSelected, setAirlineSelected] = useState(null);
  const [programSelected, setProgramSelected] = useState(null);
  const [modal, setModal] = useState(false);
  const [agree, setAgree] = useState(false);
  const [userInfo, setUserInfo] = useState(initialPassengerState);
  const [loungeInfo, setLoungeInfo] = useState(initialLoungeInfo);
  const [img, setImg] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const [phoneInfo, setPhoneInfo] = useState(phoneInformation);
  const [errors, setErrors] = useState(initialErrorsState);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const pageUrl = window.location.href;
  const [mainLanguage, setMainLanguage] = useState(defaultLanguage);
  const [termsandcond, setTermsandCond] = useState("");
  const [prodiveTermsError, setprodiveTermsError] = useState(false);
  const [clear, setClear] = useState(0);



  //TODO: we need to change the way we manage env. THis is temp solution. 
  let isProdEnv = process.env.NODE_ENV === "production" && !pageUrl.includes("qa") && !pageUrl.includes("pr");
  let envUrl = "";
  let envArsLms = "lms";
  let s3Url = "";
  let loungeCode = !pageUrl.includes("localhost")
    ? pageUrl.substring(pageUrl.lastIndexOf("/") + 1)
    : process.env.REACT_APP_TEST_LOUNGE_CODE;

  //const captchaRef = createRef();

  // Event handler to call the verification on form submit
  const handleReCaptchaVerify = useCallback(
    (e) => {
      e.preventDefault();
      if (!executeRecaptcha) {
        return;
      }

      const token = executeRecaptcha("checkRecaptcha").then((token) => {
        axios({
          method: "post",
          url: "https://www.google.com/recaptcha/api/siteverify",
          body: `secret=${process.env.REACT_APP_GCAPTCHA_SECRET}&response=${token}`,
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.score > 0.5) {
              // Save data to the database from here
              res.status(200).json({
                status: "success",
                message: "Enquiry submitted successfully",
              });
            } else {
              res.status(200).json({
                status: "failure",
                message: "Google ReCaptcha Failure",
              });
            }
          });
      });
    },
    [executeRecaptcha]
  );

  // fetch image logo and set to var on component load if one does not already exist
  // sets ENV and Lounge Logo from URL
  // prevents page reload after first render
  useEffect(() => {
    setUserInfo({ ...userInfo, env: envArsLms, loungeCode: loungeCode, language: defaultLanguage })
    FetchLoungeInfo();
    FetchLoungeTermsAndCond("en");
    setMainLanguage(defaultLanguage);
  }, []);

  // build ENV url based on URL when loading. Defaults to ARS
  const createEnvUrl = () => {
    let newUrl = "";

    if (isProdEnv) {
      if (!pageUrl.includes("qa")) {
        newUrl = pageUrl.includes("aldpos")
          ? process.env.REACT_APP_ALDPOS_API_PROD
          : process.env.REACT_APP_LMS_API_PROD;
      }
    } else if (!isProdEnv) {
      if (pageUrl.includes("qa") || pageUrl.includes("localhost")) {
        newUrl = pageUrl.includes("aldpos")
          ? process.env.REACT_APP_ALDPOS_API_DEV
          : process.env.REACT_APP_LMS_API_DEV;
      } else {
        newUrl = process.env.REACT_APP_API_LOCAL_URL
      }
    }
    return newUrl;
  };

  envUrl = createEnvUrl();

  // creates s3 URL for Logo Image
  const createS3Url = () => {
    if (isProdEnv) {
      s3Url += pageUrl.includes("lms")
        ? process.env.REACT_APP_LMS_S3_BUCKET
        : process.env.REACT_APP_ALDPOS_S3_BUCKET;
    } else {
      s3Url += pageUrl.includes("lms") || pageUrl.includes("localhost")
        ? process.env.REACT_APP_LMS_S3_BUCKET
        : process.env.REACT_APP_ALDPOS_S3_BUCKET;
    }

    return s3Url;
  };
  s3Url = createS3Url();

  // Make API call to get Lounge Logo file name
  // build up S3 Bucket string depending on ENV/LoungeCode
  // set the obj url to Img component on render.
  const FetchLoungeInfo = async () => {
    let tempImgUrl = s3Url + process.env.REACT_APP_S3_BUCKET_IMAGES;
    await axios({
      method: "post",
      url: envUrl + "getLoungeInfo",
      data: {
        env: envArsLms,
        code: loungeCode,
        isProd: isProdEnv,
        Event: "GetLoungeInfo"
      },
    })
      .then((res) => {
        //setTermsandCond(res.data.TermsAndConditions);
        setImg(true)
        setLoungeInfo({
          ...loungeInfo,
          LoungeName: res.data.LoungeName,
          LoungeCode: res.data.LoungeCode,
          WaitlistEmailLogo: res.data.WaitlistEmailLogo,
        });
        tempImgUrl += res.data.WaitlistEmailLogo;
        setImgUrl(tempImgUrl);
        setUserInfo({
          ...userInfo,
          loungeCode: res.data.LoungeCode,
          env: envArsLms,
          isProd: isProdEnv,
          loungeName: res.data.LoungeName,
          waitlistEmailLogo: res.data.WaitlistEmailLogo,
          s3Url: (s3Url += process.env.REACT_APP_S3_BUCKET_EMAIL),
        });
        setImg(true)
        setLoading(false)
      })
      .catch((err) => {
        if (err.response) {
          setErrors({
            ...errors,
            apiCallErr: true,
            apiCallErrMsg: err.response.data,
          });
          //setErrors({...errors, apiCallErr: true, apiCallErrMsg: err.response.data.status})
        } else if (err.request) {
          setErrors({ ...errors, apiCallErr: true, apiCallErrMsg: err.req });
        } else {
          setErrors({ ...errors, apiCallErr: true, apiCallErrMsg: err });
        }
      });
  };

  const FetchLoungeTermsAndCond = async (lenguage) => {
    await axios({
      method: "post",
      url: envUrl + "getLoungeInfo",
      data: {
        env: envArsLms,
        code: loungeCode,
        isProd: isProdEnv,
        Event: "gettermsandcond",
        language: lenguage
      },
    })
      .then((res) => {
        setTermsandCond(res.data.TermsAndConditions);
      })
      .catch((err) => {
        console.error(err)
      });
  };

  const AddUserToWaitlist = async (userInfo) => {
    if (isUsingNewEndpoints) {
      try {
        const waitlistData = {
          name: userInfo.name,
          outletId: outletId,
          airlineCode: AirlineSelected,
          flightNumber: userInfo.flightNumber.padStart(4, "0"),
          guestsQuantity: parseInt(userInfo.guests) || 0,
          program: userInfo.programID || "",
          ...(userInfo.email?.trim() && { email: userInfo.email.trim() }),
          ...(userInfo?.phoneNumber?.trim() && { phone: `+${userInfo.phoneNumber.trim()}` }),
          source: "self_serve"
        };

        const response = await createWaitlistEntry(baseUrl, authToken, waitlistData);
        
        // Success - show modal
        toggleModal();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        if (err.response) {
          setErrors({
            ...errors,
            apiCallErr: true,
            apiCallErrMsg: err.response.data?.message || err.response.data || "Failed to create waitlist entry",
          });
        } else if (err.request) {
          setErrors({
            ...errors,
            apiCallErr: true,
            apiCallErrMsg: "Network error. Please try again.",
          });
        } else {
          setErrors({
            ...errors,
            apiCallErr: true,
            apiCallErrMsg: err.message || "Failed to create waitlist entry",
          });
        }
      }
    } else {
      await mutation.mutate(
        {
          body: {
            ...userInfo,
            sEvent: "INSERTPASSANGER",
            guests: userInfo.guests || 0,
            infants: userInfo.infants || 0,
            flightNumber:
              AirlineSelected + userInfo.flightNumber.padStart(4, "0"),
          },
          url: envUrl + "addToWaitlist",
        },
        {
          onSuccess: (response) => {
            if (response !== "Success") {
              setErrors({
                ...errors,
                apiCallErr: true,
                apiCallErrMsg: response.data.body || response.data.errorMessage,
              });
            } else {
              toggleModal();
            }
          },
          onError: (err) => {
            if (err.response) {
              setErrors({
                ...errors,
                apiCallErr: true,
                apiCallErrMsg: err.response.data,
              });
            } else if (err.request) {
              setErrors({
                ...errors,
                apiCallErr: true,
                apiCallErrMsg: err.request,
              });
            } else {
              setErrors({ ...errors, apiCallErr: true, apiCallErrMsg: err });
            }
          },
        }
      );
    }

  };

  // submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors(initialErrorsState);
    
    //validate fields before sending request.
    let isValidForm = validateSubmitRequest();
    
    try {
      //sent request only if fields passed validation.
      if (isValidForm) {
        await AddUserToWaitlist(userInfo);
      }else{
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      if (err.response) {
        setErrors({
          ...errors,
          apiCallErr: true,
          apiCallErrMsg: err.response.data,
        });
      } else if (err.request) {
        setErrors({ ...errors, apiCallErr: true, apiCallErrMsg: err.request });
      } else {
        setErrors({ ...errors, apiCallErr: true, apiCallErrMsg: err });
      }
    }
  };

  const validateSubmitRequest = () => {
    let isvalid = true;
    let isvalidPhoneFormat = isValidPhoneNumber("+" + userInfo.phoneNumber);
    let isMissingEmail = userInfo.email === "" || userInfo.email === null;
    let isMissingPhone = userInfo.phoneNumber === "" || userInfo.phoneNumber === null;
    let isdialCode = phoneInfo.dialCode === userInfo.phoneNumber;

    //catch different senarios. 
    switch (true) {
      case (userInfo.name === "" || userInfo.name === null):
        showErroMessage("Missing name.");
        isvalid = false;
        break;
      case ((isMissingPhone || isdialCode) && isMissingEmail):
        showErroMessage("Please provide an email or phone number.");
        isvalid = false;
        break;
      case ((!isvalidPhoneFormat || isMissingPhone || isdialCode) && isMissingEmail):
        showErroMessage("Please use the right area code and length for this region.");
        isvalid = false;
        break;
      case (userInfo.flightNumber === "" || userInfo.flightNumber === null):
        showErroMessage("Missing flight number.");
        isvalid = false;
        break;
      case (parseInt(userInfo.flightNumber) <= 0 || userInfo.flightNumber.length > 4):
        showErroMessage("Incorrect flight number format.");
        isvalid = false;
        break;
      case (AirlineSelected === null):
        showErroMessage("Please select an airline.");
        isvalid = false;
        break;
      case (!agree):
        showErroMessage("Please accept the terms and conditions.");
        setprodiveTermsError(true);
        isvalid = false;
        break;
      case (userInfo.email != "" && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInfo.email))):
        showErroMessage(T("Must enter a valid email address."));
        isvalid = false;
        break;
      default:
        break;
    }

    if (!isvalid) {
      PageRef.current.scrollIntoView({ behavior: "smooth", block: "end" })
    }

    return isvalid;
  }

  const showErroMessage = message => {
    setErrors({
      ...errors,
      error: true,
      errorMsg: T(message),
    });
  }

  const handleAirlines = (airline) => setAirlineSelected(airline?.value || null);

  // handles form input
  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });

    if (e.target.name === "name" && e.target.value.length <= 2) {
      setErrors({
        ...errors,
        nameErr: true,
        nameErrMsg: T("Length must be greater than 2 characers."),
      });
      return;
    } else if (e.target.name === "email") {
      if (((e.target.value !== "" && e.target.value !== null) && (e.target.value === undefined || e.target.value.length <= 2 ||
        !e.target.value.match(new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))))) {
        setErrors({
          ...errors,
          emailErr: true,
          emailErrMsg: T("Must enter a valid email address."),
        });
      } else {
        setErrors({
          ...errors,
          emailErr: false,
          emailErrMsg: "",
        });
      }
      return;
    } else if (e.target.name === "guests" && (e.target.value < 0 || e.target.value > 9)) {
      setErrors({
        ...errors,
        guestsErr: true,
        guestsErrMsg: T("Please, select a number between 0 and 9."),
      });
      return;
    } else if (e.target.name === "infants" && (e.target.value < 0 || e.target.value > 9)) {
      setErrors({
        ...errors,
        infantsErr: true,
        infantsErrMsg: T("Please, select a number between 0 and 9."),
      });
      return;
    } else if (e.target.name === "flightNumber" && (e.target.value === "" || e.target.value === undefined)) {
      setErrors({
        ...errors,
        flightNumberErr: true,
        flightNumberMsg: T("Please enter the flight number."),
      });
      return;
    } else if (e.target.name === "flightNumber" && (parseInt(e.target.value) <= 0 || e.target.value.length > 4)) {
      const error = e.target.value.length > 4 ? "Can't have more than 4 digits." : "Must be above 0.";
      setErrors({
        ...errors,
        flightNumberErr: true,
        flightNumberMsg: T(error)
      });
      return;
    } else {
      setErrors(initialErrorsState);
    }
  };

  const handleLanguageChanged = language => {
    setMainLanguage(language);
    setUserInfo({ ...userInfo, language: language });
    FetchLoungeTermsAndCond(language)
    setTimeout(() => {
      Config.default = "";
      localStorage.setItem("rtc-lang", "");
    }, 1000);
  }

  // hides/shows modal on click/toggle
  // reset passenger info after toggle to preserve state to modal message/translation
  // if modal is active after submission, upon closing will clear the form but retain the ENV inputs/url
  const toggleModal = (success = false) => {
    setModal(!modal);
    setLoading(false);
    //reset values if success.
    if (modal && (userInfo.phoneNumber === "" || userInfo.phoneNumber === null)) {
      phoneInfo.dialCode = defaultAreaCode;
    }
    modal && setUserInfo({ ...userInfo, name: "", email: "", phoneNumber: phoneInfo.dialCode, guests: "", flightNumber: "" });
    setClear((prev) => prev + 1);
    modal && setAgree(false);
  };

  return (
    <div ref={PageRef}>
      {img && <h1>{TF("Welcome to") + ` ${loungeInfo.LoungeName}!`}</h1>}
      <Media id="loungeLogo">
        <img src={imgUrl} alt="" />
      </Media>
      <div style={{ textAlign: "left", marginBottom: 10 }}>
        {T(
          "Provide your name, flight information, email, and/or phone number so that we may contact you about lounge availability."
        )}
      </div>
      <LanguageRadioInput languageDefault={mainLanguage} updateLanguage={handleLanguageChanged} />
      <form id="passengerForm" className="inline-flex" onSubmit={loading ? undefined : handleSubmit}>
        <Container>
          <ControlledTextInput
            name="name"
            handleChange={handleChange}
            value={userInfo.name}
            placeholder={T("Passenger Name")}
          />
          <ControlledTextInput
            name="email"
            handleChange={handleChange}
            value={userInfo.email}
            placeholder={T("Email")}
          />
          <PhoneInput
            inputStyle={{
              borderStyle: "solid",
              borderRadius: "5px",
              borderWidth: "4px",
              width: "100%"
            }}
            buttonStyle={{
              borderColor: "transparent",
              margin: "4px",
              backgroundColor: "rgba(255, 255, 255, 0)",
            }}
            autoFormat="true"
            country={"us"}
            value={userInfo.phoneNumber}
            onChange={(value, info) => {
              setPhoneInfo({
                ...phoneInformation,
                countryCode: info.countryCode,
                dialCode: info.dialCode,
                name: info.name,
              });
              setUserInfo({ ...userInfo, phoneNumber: value });
            }}
          />
          {isUsingNewEndpoints ? (
            <ProgramsSelectInputNew
              value={programSelected}
              handleChange={handleChange}
            />
          ) : (
            <ProgramsSelectInput
              value={programSelected}
              handleChange={handleChange}
            />
          )}
          <Wrapper direction="horizontal" gap={"1rem"}>
            <AirlinesAutocompleteInput
              handleChange={handleAirlines}
              placeHolder={T("Flight Airline")}
              clear={clear}
            />
            <ControlledTextInput
              name="flightNumber"
              handleChange={event => {
                const newValue = event.target.value;
                if (/^\d*$/.test(newValue) && newValue.length <= 4) {
                  handleChange(event);
                }
              }}
              value={userInfo.flightNumber}
              placeholder={T("Flight Number - E.g 1234")}
              warning={errors.flightNumberTimeErr}
            />
          </Wrapper>
          <Wrapper direction="horizontal" gap={"1rem"}>
            <ControlledTextInput
              name="guests"
              handleChange={event => {
                const newValue = event.target.value;
                if (/^\d*$/.test(newValue)) {
                  handleChange(event);
                }
              }}
              value={userInfo.guests}
              placeholder={T("Guest Count")}
              warning={errors.guestsErr}
            />
            <ControlledTextInput
              name="infants"
              handleChange={event => {
                const newValue = event.target.value;
                if (/^\d*$/.test(newValue)) {
                  handleChange(event);
                }
              }}
              value={userInfo.infants}
              placeholder={T("Infants under 2 yrs")}
              warning={errors.infantsErr}
            />
          </Wrapper>
          <FormGroup check>
            <Input
              id="checkbox"
              type="checkbox"
              checked={agree}
              invalid={prodiveTermsError}
              onChange={(e) => {
                setAgree(e.target.checked);
                setprodiveTermsError(false);
                setErrors(initialErrorsState);
              }}
            />
            <Label check>
              {T("I have read, understand, and agree to the ")}
              <a
                style={{
                  textDecoration: "none",
                  color: "blue",
                  textDecorationLine: "underline",
                }}
                onClick={() => toggleTermsAndConditionModal.toggle()}
              >
                {T("Terms and Conditions")}
              </a>
              {T(" for this platform. ")}
              {/* <a href="https://www.collinsongroup.com/en/privacy-policy" target="_blank" rel="noopener noreferrer" tabindex="0" role="button" data-testid="inline-card-resolved-view" class="css-1n28348 eeajecn1"><span data-testid="inline-card-icon-and-title" class="css-1h3cbh4 e158gagu6"><span class="css-sowgxi e158gagu2"><span class="css-vehdi e158gagu1"></span><img class="smart-link-icon css-qg49p3 e1bjtjov1" src="https://www.collinsongroup.com/favicon.ico" data-testid="inline-card-icon-and-title-image"/></span><span class="smart-link-title-wrapper css-0 e158gagu0">{T("Privacy Policy | Collinson Group")}</span></span></a> */}
              <a
                style={{
                  textDecoration: "none",
                  color: "blue",
                  textDecorationLine: "underline",
                }}
                target="_blank"
                rel="noopener noreferrer"
                href={"https://www.collinsongroup.com/en/privacy-policy"}
              >
                {T("Privacy Policy | Collinson Group")}
              </a>
            </Label>
            <FormFeedback>
              {/* {T("Please accept the terms and conditions.")} */}
            </FormFeedback>
          </FormGroup>
          <Button type="submit" disabled={loading}>
            <FontAwesomeIcon id="submitIcon" icon={faArrowRightToBracket} />
            {loading ? (
              <>
                <Spinner size="sm" />
                {" "}
                {TF("...joining")} {loungeInfo.LoungeName} {T("wait list")}
              </>
            ) : (
              T("Join Wait List")
            )}
          </Button>
          <Row>
            <Col md={12}>
              {errors.error || errors.apiCallErr ? (
                <Alert id="alert" color="danger" fade={true}>
                  {T(errors.errorMsg || errors.apiCallErrMsg)}
                </Alert>
              ) : null}
            </Col>
          </Row>
        </Container>
      </form>
      {!errors.error && (
        <Modal
          id="modal"
          isOpen={modal}
          toggle={toggleModal}
          centered
          size="lg"
        >
          <ModalHeader toggle={toggleModal}>
            {TF("Thank you") + ` ${userInfo.name}!`}
          </ModalHeader>
          <ModalBody>
            {TF("You have been successfully added to the") +
              ` ${loungeInfo.LoungeName} ` +
              T("wait list! ") +
              T(
                "We will send you an email and/or SMS once space is available."
              )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => { toggleModal(true); setAirlineSelected(null); }}>
              {T("Ok")}
            </Button>{" "}
          </ModalFooter>
        </Modal>
      )}
      <div className="languageList">
        <LanguageList Language={mainLanguage} />
      </div>
      <TermsAndConditionModal
        modal={toggleTermsAndConditionModal}
        cancelButtonText={T("Close")}
        message={termsandcond}
      />
    </div>
  );
};

export default PassengerForm;